var PalantirTagModule = /** @class */ (function () {
    function PalantirTagModule() {
    }
    return PalantirTagModule;
}());
export { PalantirTagModule };
